module.exports = __webpack_public_path__ + "img/icon_yishenqinghong.7e436819.svg";